module.exports = __webpack_public_path__ + "images/store_case_study/southleaf-pic2_3679f076b0824bdc65da1a48487b78c6.png";